import { PersonalitySlider, LogoExample, ColorPalette, StyleOption } from '../types';

export const personalitySliders: PersonalitySlider[] = [
  {
    id: 'modernClassic',
    left: 'Modern',
    right: 'Classic'
  },
  {
    id: 'playfulSerious',
    left: 'Playful',
    right: 'Serious'
  },
  {
    id: 'luxuryEconomical',
    left: 'Luxury',
    right: 'Economical'
  },
  {
    id: 'minimalistDetailed',
    left: 'Minimalist',
    right: 'Detailed'
  },
  {
    id: 'boldSubtle',
    left: 'Bold',
    right: 'Subtle'
  }
];

export const logoExampleOptions: LogoExample[] = [
  {
    id: 1,
    image: 'https://marketplace.canva.com/EAF7dNjM5fg/1/0/1600w/canva-logos-con-iniciales-para-nombre-sencillo-tipogr%C3%A1fico-circular-blanco-y-negro-iIOpW3mk-yQ.jpg'
  },
  {
    id: 2,
    image: 'https://img.freepik.com/vector-gratis/diseno-logotipo-vector-letras-e_557339-691.jpg'
  },
  {
    id: 3,
    image: 'https://marketplace.canva.com/EAFJy5_-fBY/1/0/1600w/canva-logo-comida-empanadas-ilustrativo-negro-WLMg9lXdPcA.jpg'
  },
  {
    id: 4,
    image: 'https://marketplace.canva.com/EAFbCxgyHF0/1/0/1600w/canva-black-and-white-aesthetic-minimalist-modern-simple-typography-coconut-cosmetics-logo-jUM1MX-sRvw.jpg'
  },
  {
    id: 5,
    image: 'https://marketplace.canva.com/EAF9iwmYYPw/1/0/1600w/canva-logo-tienda-ecol%C3%B3gica-minimalista-beige--AbA3ALwAuw.jpg'
  },
  {
    id: 6,
    image: 'https://marketplace.canva.com/EAGREpMnink/1/0/1600w/canva-blue-white-bold-playful-kids-clothing-logo-NloJkyBk-OI.jpg'
  },
  {
    id: 7,
    image: 'https://static-cse.canva.com/blob/572480/OrangeandWhiteBurgersandShakesLogo.png'
  },
  {
    id: 8,
    image: 'https://static-cse.canva.com/blob/703948/logotemp1.png'
  },
  {
    id: 9,
    image: 'https://marketplace.canva.com/EAFYL6Ckhfo/1/0/1600w/canva-bright-colorful-playful-funny-donuts-food-circle-logo-pDkTGKYJQmI.jpg'
  },
  {
    id: 10,
    image: 'https://marketplace.canva.com/EAGGDjg4BSY/1/0/1600w/canva-logo-parrilla-argentina-circular-marr%C3%B3n-y-negro-VN3qR8Fda0M.jpg'
  },
  {
    id: 11,
    image: 'https://marketplace.canva.com/EAFccLNG0ck/1/0/1600w/canva-logo-con-tipograf%C3%ADa-para-iniciales-del-nombre-profesional-circular-limpio-elegante-blanco-negro-EaawOr6oNWY.jpg'
  },
  {
    id: 12,
    image: 'https://marketplace.canva.com/EAFWgmDygYc/1/0/1600w/canva-logo-circular-floral-negro-aamNJhhroKY.jpg'
  },
  {
    id: 13,
    image: 'https://marketplace.canva.com/EAFHin1sA_U/2/0/1600w/canva-logo-sobre-moda-femenina-minimalista-neutral-f1Gpa5rAmMw.jpg'
  },
  {
    id: 14,
    image: 'https://marketplace.canva.com/EAGDODutHxQ/1/0/1600w/canva-logo-marca-personal-con-tipograf%C3%ADa-de-iniciales-dise%C3%B1o-minimalista-aesthetic-crema-HrKYqCkCCR8.jpg'
  },
  {
    id: 15,
    image: 'https://marketplace.canva.com/EAGYIy4AT3g/1/0/1600w/canva-logo-logotipo-marca-personal-negocio-sencillo-rosa-7wtzZQePMUw.jpg'
  },
  {
    id: 16,
    image: 'https://marketplace.canva.com/EAGEeqwR-JU/1/0/1600w/canva-logo-para-marca-personal-en-negro-y-rosa-IWq6hLNASJ4.jpg'
  },
  {
    id: 17,
    image: 'https://marketplace.canva.com/EAF-h9Q8YyY/1/0/1600w/canva-logo-artista-de-u%C3%B1as-elegante-beige-qGMu8RuuzSA.jpg'
  },
  {
    id: 18,
    image: 'https://marketplace.canva.com/EAFQ9j2VtTU/1/0/1600w/canva-logo-moda-femenina-minimalista-negro-y-rosa-9xwcBlDOQ_8.jpg'
  },
  {
    id: 19,
    image: 'https://marketplace.canva.com/EAF5V9i5G5g/1/0/1600w/canva-logotipo-cafeter%C3%ADa-figurativo-caf%C3%A9-y-beige-rxcvtLtKSx8.jpg'
  },
  {
    id: 20,
    image: 'https://marketplace.canva.com/EAGCuZ6hhao/1/0/1600w/canva-logotipo-circular-pasteler%C3%ADa-ilustrativo-negro-EdUFa7gKtZY.jpg'
  },
  {
    id: 21,
    image: 'https://marketplace.canva.com/EAFCyC9aHzU/1/0/1600w/canva-logo-para-taller-mec%C3%A1nico-ilustrado-cjEg8SslVIU.jpg'
  },
  {
    id: 22,
    image: 'https://marketplace.canva.com/EAGRZamxP_4/1/0/1600w/canva-logo-farmacia-medicina-minimalista-simple-verde-56tDv1VOh4E.jpg'
  },
  {
    id: 23,
    image: 'https://marketplace.canva.com/EAFIRuGb37s/2/0/1600w/canva-logo-chef-simple-moderno-plano-blanco-y-negro-LOsHnz3vNEc.jpg'
  },
  {
    id: 24,
    image: 'https://marketplace.canva.com/EAFjGq9TGM4/1/0/1600w/canva-logotipo-iniciales-profesional-negro-rojo-_Q1kYtXStF8.jpg'
  },
  {
    id: 25,
    image: 'https://marketplace.canva.com/EAE_G88CpOU/1/0/1600w/canva-logotipo-moda-deportiva-simple-blanco-kYyAeBOk_Jw.jpg'
  },
  {
    id: 26,
    image: 'https://marketplace.canva.com/EAGNq285F4s/1/0/1600w/canva-logotipo-indumentaria-femenina-floral-beige-wOxmb6q3fGo.jpg'
  },
  {
    id: 27,
    image: 'https://template.canva.com/EAFcglLYlOU/1/0/800w-4iqUf29TXzY.jpg'
  },
  {
    id: 28,
    image: 'https://marketplace.canva.com/EAFro_4WQgY/2/0/1600w/canva-logotipo-agente-inmobiliario-moderno-hC_WZUAfQ2w.jpg'
  },
  {
    id: 29,
    image: 'https://marketplace.canva.com/EAFuZ6mndk0/1/0/1600w/canva-black-and-beige-minimalist-aesthetic-modern-simple-typography-agency-logo-nOmD_liBjZo.jpg'
  },
  {
    id: 30,
    image: 'https://marketplace.canva.com/EAF-a_Bbi7M/1/0/1600w/canva-black-and-white-circle-business-logo-QWY_jVRjydc.jpg'
  },
  {
    id: 31,
    image: 'https://marketplace.canva.com/EAFsGLwjnSI/1/0/1600w/canva-gray-and-black-simple-studio-logo-Xif3OUAyjuA.jpg'
  },
  {
    id: 32,
    image: 'https://marketplace.canva.com/EAGH2LPpmFQ/1/0/1600w/canva-dark-green-modern-initial-logo-6NXpIsxaL50.jpg'
  },
  {
    id: 33,
    image: 'https://marketplace.canva.com/EAEyS4ATpB8/1/0/1600w/canva-clean-minimalist-c-g-letter-interior-design-logo-TImR2q3Hy9I.jpg'
  },
  {
    id: 34,
    image: 'https://marketplace.canva.com/EAFk9yoPLSs/1/0/1600w/canva-pink-cute-illustration-donut-logo-A9533RJ5rZI.jpg'
  },
  {
    id: 35,
    image: 'https://marketplace.canva.com/EAGJ-XfVf9M/2/0/1600w/canva-pink-modern-simple-bakery-logo-xybCGjXVlsw.jpg'
  },
  {
    id: 36,
    image: 'https://marketplace.canva.com/EAFo5uHuB2w/1/0/1600w/canva-black-and-white-simple-y2k-fashion-logo-9stvaqHFFmA.jpg'
  },
  {
    id: 37,
    image: 'https://marketplace.canva.com/EAFyjXFvi-A/1/0/1600w/canva-black-and-white-modern-typographic-simple-virus-apparel-logo-EJSByCIOI7w.jpg'
  },
  {
    id: 38,
    image: 'https://marketplace.canva.com/EAGJGHF99lc/1/0/1600w/canva-minimalist-simple-typography-milk-creative-studio-logo-pdf8fFmrFvM.jpg'
  },
  {
    id: 39,
    image: 'https://marketplace.canva.com/EAGBearLH2s/1/0/1600w/canva-black-and-grey-modern-graffiti-ginger-company-logo-ldqMKamFU_o.jpg'
  },
  {
    id: 40,
    image: 'https://marketplace.canva.com/EAGGf9v-XnM/1/0/1600w/canva-black-and-white-minimalist-graffiti-urban-brand-logo-9wPyuuPbmfo.jpg'
  }
];

export const styleOptions: StyleOption[] = [
  {
    name: 'Minimalist',
    description: 'Clean, simple designs that focus on essential elements',
    image: 'https://www.adobe.com/creativecloud/design/discover/media_17770be5de64c9b159b23a7da870ae0bd5bc0f400.jpeg?width=1200&format=pjpg&optimize=medium'
  },
  {
    name: 'Geometric',
    description: 'Designs based on mathematical shapes and patterns',
    image: 'https://cdn.shopify.com/s/files/1/0558/6413/1764/files/2024_Logo_Design_Trend_Geometric_Shapes_and_Abstract_Imagery_1_1024x1024.jpg?v=1701423343'
  },
  {
    name: 'Mascot',
    description: 'Character-based designs that add personality',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbqjPqjigJwHu4VvBHRbIMuIO7TD9qgiE-kw&s'
  },
  {
    name: 'Emblem',
    description: 'Traditional badge or seal-style designs',
    image: 'https://cdn.logojoy.com/wp-content/uploads/20221011133323/Porsche-emblem-logo-symbol-600x600.jpg'
  },
  {
    name: 'Wordmark',
    description: 'Text-based designs with unique typography',
    image: 'https://logomaster.ai/hs-fs/hubfs/wordmark-logo-coca-cola.jpg?width=1700&height=1148&name=wordmark-logo-coca-cola.jpg'
  },
  {
    name: 'Combination',
    description: 'Designs that merge symbols with text',
    image: 'https://media.licdn.com/dms/image/v2/C5612AQEUEC8zLwZtlg/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1594768754627?e=2147483647&v=beta&t=jlsMEWP4YqG_SKbMWTjZy1QjqHLejOlykcHG_95inU4'
  },
  {
    name: 'Lettermark',
    description: 'Monogram-style designs using initials',
    image: 'https://logomaster.ai/hs-fs/hubfs/lettermark-logo-cnn.jpg?width=1700&height=1148&name=lettermark-logo-cnn.jpg'
  },
  {
    name: 'Letterforms',
    description: 'Single letter designs with creative styling',
    image: 'https://blog.placeit.net/wp-content/uploads/2022/05/Netflix-Letterform-Logo-Design.png'
  }
];

export const colorPalettes: ColorPalette[] = [
  {
    name: 'Enchanted Forest',
    colors: ['#3A5A40', '#588157', '#A3B18A', '#DAD7CD', '#FFFFFF']
  },
  {
    name: 'Desert Sunset',
    colors: ['#D4A59A', '#EF7C8E', '#FEE8B0', '#B2ECE1', '#8CA1A5']
  },
  {
    name: 'Deep Ocean',
    colors: ['#012A4A', '#013A63', '#01497C', '#2C7DA0', '#61A5C2']
  },
  {
    name: 'Vintage Coffee',
    colors: ['#6F4E37', '#C4A484', '#E6D5B8', '#EDE6DB', '#1E1E1E']
  },
  {
    name: 'Northern Lights',
    colors: ['#4B3F72', '#7D70BA', '#CBB3BF', '#FFC857', '#119DA4']
  },
  {
    name: 'Urban Minimalist',
    colors: ['#333333', '#666666', '#999999', '#CCCCCC', '#FFFFFF']
  },
  {
    name: 'Tropical Fruits',
    colors: ['#FF6B6B', '#4ECDC4', '#FFE66D', '#FF9F1C', '#A8D8EA']
  },
  {
    name: 'Nordic Mountain',
    colors: ['#2F3E46', '#354F52', '#52796F', '#84A98C', '#CAD2C5']
  },
  {
    name: 'Hot Spices',
    colors: ['#A4243B', '#D8C99B', '#D8973C', '#BD632F', '#273E47']
  },
  {
    name: 'Twilight Sky',
    colors: ['#355070', '#6D597A', '#B56576', '#E56B6F', '#EAAC8B']
  },
  {
    name: 'Botanical Garden',
    colors: ['#466365', '#B49A67', '#CEB3AB', '#C4C6E7', '#BAFF29']
  },
  {
    name: 'Sand and Sea',
    colors: ['#E9C46A', '#F4A261', '#E76F51', '#2A9D8F', '#264653']
  },
  {
    name: 'Starry Night',
    colors: ['#0B132B', '#1C2541', '#3A506B', '#5BC0BE', '#6FFFE9']
  },
  {
    name: 'Lavender and Honey',
    colors: ['#B388EB', '#DDD5F3', '#F7AF9D', '#F7DBA7', '#1E1E1E']
  },
  {
    name: 'Futuristic City',
    colors: ['#00B4D8', '#0077B6', '#03045E', '#48CAE4', '#90E0EF']
  },
  {
    name: 'Green Tea',
    colors: ['#606C38', '#283618', '#FEFAE0', '#DDA15E', '#BC6C25']
  },
  {
    name: 'Fire and Ice',
    colors: ['#FF5400', '#FF9E00', '#FFEE00', '#00B4D8', '#00509D']
  },
  {
    name: 'Gemstones',
    colors: ['#5E503F', '#A9927D', '#D4B483', '#3A5A40', '#1D3557']
  },
  {
    name: 'Tropical Jungle',
    colors: ['#386641', '#6A994E', '#A7C957', '#F2E8CF', '#BC4749']
  },
  {
    name: 'Pink Marble',
    colors: ['#EAC7C7', '#F7D9D9', '#E8A0BF', '#BA90C6', '#C0DBEA']
  },
  {
    name: 'Salt Desert',
    colors: ['#F8F3E6', '#D3D5D4', '#A5C9CA', '#E2B4BD', '#9B6A6C']
  },
  {
    name: 'Winter Sky',
    colors: ['#E2F1F8', '#B5D6E7', '#93C6E7', '#5E8EC9', '#3A5A78']
  },
  {
    name: 'Dark Chocolate',
    colors: ['#3D2B1F', '#6F4E37', '#C4A484', '#E6D5B8', '#1E1E1E']
  },
  {
    name: 'Wildflowers',
    colors: ['#FFADAD', '#FFD6A5', '#FDFFB6', '#CAFFBF', '#9BF6FF']
  },
  {
    name: 'Moonstone',
    colors: ['#D8E2DC', '#FFE5D9', '#FFCAD4', '#F4ACB7', '#9D8189']
  },
  {
    name: 'Rusted Copper',
    colors: ['#6B2D5C', '#F0386B', '#FF5376', '#F8C0C8', '#E2C290']
  },
  {
    name: 'Polar Night',
    colors: ['#0F1A20', '#3A4E57', '#6B8F94', '#9FC2CC', '#D3E0E5']
  },
  {
    name: 'Mint and Lemon',
    colors: ['#CCE3DE', '#A4C3B2', '#6B9080', '#F6FFF8', '#FFD166']
  },
  {
    name: 'Sahara Sand',
    colors: ['#EDD4B2', '#D0A98F', '#988467', '#675645', '#3D2B1F']
  },
  {
    name: 'Sunrise Sky',
    colors: ['#FFB347', '#FF8C42', '#FF6B35', '#FF3A1F', '#D10000']
  },
  {
    name: 'Volcanic Stone',
    colors: ['#3D3D3D', '#5E5E5E', '#8D8D8D', '#C4C4C4', '#FF5E5E']
  },
  {
    name: 'Serene Lake',
    colors: ['#5C6B73', '#8FA6A6', '#D4DCCD', '#F0F4E3', '#A6C4D9']
  },
  {
    name: 'Red Wine',
    colors: ['#3D0C11', '#5E1914', '#8B2A2A', '#B84A4A', '#E87575']
  },
  {
    name: 'Copper and Bronze',
    colors: ['#B76D68', '#E3A587', '#F2D0A4', '#C1C9C8', '#6E7F80']
  },
  {
    name: 'Morning Mist',
    colors: ['#E0E1DD', '#778DA9', '#415A77', '#1B263B', '#0D1B2A']
  },
  {
    name: 'Zen Garden',
    colors: ['#5E747F', '#7B9E89', '#D6E5E3', '#EFC88B', '#DE7356']
  },
  {
    name: 'Coral and Pearl',
    colors: ['#FF7E6B', '#FFC2B5', '#F8F4E3', '#A5C4D4', '#7A9CC6']
  },
  {
    name: 'Antique Copper',
    colors: ['#A26769', '#CEB3AB', '#D8CFAF', '#E8D6CB', '#6B4D57']
  },
  {
    name: 'Marshland',
    colors: ['#4A6B6F', '#6F8F8E', '#A3B9A8', '#D9D9C5', '#F2E2CE']
  },
  {
    name: 'Golden Luxury',
    colors: ['#D4AF37', '#E5C687', '#F5E5C0', '#3A3A3A', '#1A1A1A']
  },
  {
    name: 'Cloudy Sky',
    colors: ['#B0C4DE', '#D3D3D3', '#A9A9A9', '#778899', '#696969']
  },
  {
    name: 'Dark Emerald',
    colors: ['#1E3D2B', '#3A5A40', '#588157', '#A3B18A', '#DAD7CD']
  },
  {
    name: 'Copper and Terracotta',
    colors: ['#9C6644', '#B87D4B', '#D4A373', '#E6C79C', '#F2E0C9']
  },
  {
    name: 'City Night',
    colors: ['#2D3142', '#4F5D75', '#BFC0C0', '#FFFFFF', '#EF8354']
  },
  {
    name: 'Strawberries and Cream',
    colors: ['#FF6392', '#FF9EB7', '#FFCDB2', '#F8EDEB', '#D8E2DC']
  },
  {
    name: 'Minerals',
    colors: ['#6B9080', '#A4C3B2', '#CCE3DE', '#EAF4F4', '#F6FFF8']
  },
  {
    name: 'Sky and Earth',
    colors: ['#5E503F', '#A9927D', '#D4B483', '#3A5A40', '#1D3557']
  }
];